import React from "react";
import GTCConsent from "../GTCConsent/GTCConsent";
import Consent from "../Consent/Consent";
const consentList = (props) => {
  return (
    <>
      {props.consents.map((consent, index) =>
        props.GTC ? (
          <GTCConsent
            key={index}
            handleConsentChange={props.handleConsentChange}
            consent={consent}
          />
        ) : (
          <Consent
            key={index}
            handleConsentChange={props.handleConsentChange}
            consent={consent}
            type={props.type}
          />
        )
      )}
    </>
  );
};

export default consentList;
